<p-card [style]="{ margin: 0, height: '100%' }">
  <div class="filters-container mb-3">
    <div class="filters-header">
      <h3 class="filters-title">Filtres</h3>
      <p-button
        label="Réinitialiser"
        icon="pi pi-filter-slash"
        severity="secondary"
        (onClick)="resetFilters()"
        [outlined]="true"
        [text]="true"
        size="small"
      ></p-button>
    </div>

    <form [formGroup]="filtersForm" class="filters-row">
      <!-- Barre de recherche -->
      <div class="filter-item filter-search">
        <span class="filter-label">Recherche</span>
        <div class="filter-content">
          <p-iconField iconPosition="left" styleClass="w-full">
            <p-inputIcon>
              <i class="pi pi-search"></i>
            </p-inputIcon>
            <input
              pInputText
              type="text"
              placeholder="Rechercher"
              formControlName="search"
              class="search-input"
            />
          </p-iconField>
        </div>
      </div>

      <!-- Filtre de sociétés -->
      <div class="filter-item filter-society">
        <span class="filter-label">Sociétés</span>
        <div class="filter-content society-filter">
          @for (society of mlSocieties; track $index) {
            <app-custom-checkbox
              [value]="society"
              formControlName="societyKeys"
              [hoverColorClass]="'text-' + society"
            >
              <i checkbox-icon [class]="'tll tll-24 fa-logo-' + society"></i>
            </app-custom-checkbox>
          }
        </div>
      </div>

      <!-- Filtre de départements -->
      <div class="filter-item">
        <span class="filter-label">Départements</span>
        <div class="filter-content">
          <p-multiSelect
            [options]="departments"
            formControlName="departments"
            optionLabel="name"
            optionValue="code"
            [style]="{ width: '100%' }"
            placeholder="Sélectionner"
            display="chip"
          ></p-multiSelect>
        </div>
      </div>

      <!-- Filtre de codes produits -->
      <div class="filter-item">
        <span class="filter-label">Produits</span>
        <div class="filter-content">
          <p-multiSelect
            [options]="products"
            formControlName="products"
            optionLabel="name"
            optionValue="id"
            [style]="{ width: '100%' }"
            placeholder="Sélectionner"
            display="chip"
          ></p-multiSelect>
        </div>
      </div>

      <!-- Filtre de secteurs -->
      <div class="filter-item">
        <span class="filter-label">Secteurs</span>
        <div class="filter-content">
          <p-multiSelect
            [options]="sectors"
            formControlName="sectors"
            optionLabel="name"
            optionValue="id"
            [filter]="true"
            filterBy="name"
            [style]="{ width: '100%' }"
            placeholder="Sélectionner"
            display="chip"
          ></p-multiSelect>
        </div>
      </div>
    </form>
  </div>

  <p-table
    #dt
    [paginator]="true"
    styleClass="p-datatable-sm"
    [rowsPerPageOptions]="[5, 10, 20]"
    [totalRecords]="(totalRecords$ | async) || 0"
    [columns]="cols"
    [value]="(users$ | async) || []"
    [loading]="loading$ | async"
    [rows]="10"
    [lazy]="true"
    (onLazyLoad)="lazyLoadEmit($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th>ID</th>
        <th>Couleur</th>
        <th>Initiales</th>
        <th>Nom</th>
        <th>Prénom</th>
        <th>Email</th>
        <th>Société</th>
        <th>Actions</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr style="height: 46px">
        <td>{{ rowData.id }}</td>
        <td>
          <div
            class="color-indicator"
            [ngStyle]="{ 'background-color': rowData.color || '#ccc' }"
            title="{{ rowData.color }}"
          ></div>
        </td>
        <td>{{ rowData.initials }}</td>
        <td>{{ rowData.lastname }}</td>
        <td>{{ rowData.firstname }}</td>
        <td>{{ rowData.email }}</td>
        <td><i [class]="getUserSource(rowData)"></i></td>
        <td>
          <p-button
            severity="secondary"
            icon="pi pi-pencil"
            (onClick)="show(rowData)"
          />
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingicon">
      <p-progressSpinner
        ariaLabel="loading"
        styleClass="w-4rem h-4rem"
        strokeWidth="5"
      />
    </ng-template>
  </p-table>
</p-card>
